/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
import Cookies from 'js-cookie';
import { USER_COOKIE_KEY } from '../config';

export const getUserInfo = () => {
  const userInfo = Cookies.getJSON(USER_COOKIE_KEY);
  if (userInfo) {
    return userInfo;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/services/user.js